var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c("formBox", {
            ref: "formBox",
            attrs: { total: _vm.total },
            on: {
              confirmData: _vm.confirmData,
              getExportData: _vm.getExportData,
            },
          }),
          _vm._v(" "),
          _vm.tableData.length > 0
            ? _c(
                "div",
                { staticClass: "mt10" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.tableLoading,
                          expression: "tableLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        height: _vm.tableHeight,
                        "default-expand-all": "",
                        "row-key": "id",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "申请人",
                          "min-width": "120",
                          prop: "card.name",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("div", { staticClass: "flex" }, [
                                    _c("img", {
                                      staticClass: "img",
                                      attrs: { src: row.card.avatar, alt: "" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(row.card.name))]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          598180127
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "部门",
                          "min-width": "150",
                          prop: "frame.name",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "审批类型",
                          "min-width": "150",
                          prop: "approve.name",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "审批状态",
                          "min-width": "120",
                          prop: "name",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status === -1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "plain",
                                            size: "mini",
                                            type: "info",
                                          },
                                        },
                                        [_vm._v(" 已撤销 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "plain",
                                            size: "mini",
                                            type: "warning",
                                          },
                                        },
                                        [_vm._v(" 待审核 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "plain",
                                            size: "mini",
                                            type: "info",
                                          },
                                        },
                                        [_vm._v(" 已通过 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 2
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            effect: "plain",
                                            size: "mini",
                                            type: "danger",
                                          },
                                        },
                                        [_vm._v(" 已拒绝 ")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3904845750
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "提交时间",
                          "min-width": "150",
                          prop: "created_at",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("public.operation"),
                          prop: "name",
                          "show-overflow-tooltip": "",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "business:record:index:details",
                                          ],
                                          expression:
                                            "['business:record:index:details']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "business:record:index:delete",
                                          ],
                                          expression:
                                            "['business:record:index:delete']",
                                        },
                                      ],
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3891664191
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-fixed" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.where.page,
                          "page-size": _vm.where.limit,
                          "page-sizes": [15, 20, 30],
                          total: _vm.total,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.pageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("default-page", {
                    directives: [{ name: "height", rawName: "v-height" }],
                    attrs: { index: 14, "min-height": 320 },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          "export-data": _vm.exportData,
          "save-name": _vm.saveName,
          template: false,
        },
      }),
      _vm._v(" "),
      _c("detail-examine", { ref: "detailExamine" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }